/**
 * Feature flag for the Simulation V3 screen (NFR-9: flag off ⇒ zero change).
 *
 * IMPORTANT: this file must stay free of imports from the rest of the
 * simulationV3 module. App.js imports it directly to decide whether to
 * register the /masterplanograms/v3 route; pulling module internals here
 * would defeat the lazy code-split (the v3 chunk must not load while the
 * flag is off).
 *
 * Pattern mirrors REACT_APP_AI_SIMULATION_BUTTON /
 * REACT_APP_AI_SIMULATION_BUTTON_USER_ID in src/_services/common.service.js.
 */

const flagValue = process.env.REACT_APP_SIMULATION_V3 || 'false'

const allowedUserIds = (process.env.REACT_APP_SIMULATION_V3_USER_ID || '')
  .split(',')
  .map((id) => id.trim())
  .filter((id) => id)

/**
 * Returns true when the Simulation V3 screen is enabled.
 *
 * - `REACT_APP_SIMULATION_V3` unset or not "true" → always false.
 * - `REACT_APP_SIMULATION_V3_USER_ID` set (comma-separated ids) → the flag
 *   additionally requires the current user's id to be in the list.
 */
export const isSimulationV3Enabled = (
  userId?: string | number | null
): boolean => {
  if (flagValue !== 'true') return false
  if (allowedUserIds.length === 0) return true
  return userId !== null && userId !== undefined
    ? allowedUserIds.includes(String(userId))
    : false
}
